import { Box, Grid, IconButton, InputAdornment, Typography, } from '@mui/material'
import { styled } from '@mui/material/styles'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

/** ROUTE */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import VisibilityIcon from '@mui/icons-material/Visibility'
import OverdueApi from 'api/finances/overdue.api'
import ClinicApi from 'api/master/clinic.api'
import { notiError } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { colors } from 'constants/theme'
import _ from 'lodash'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import { useTranslation } from 'react-i18next'
import { routeName } from 'routes/routes-name'
import { getBranch, numberFormat, numberToCurrencyFormat } from 'utils/app.utils'
import { dateToView } from 'utils/date.utils'
import { exportOverdueDetailToExcel } from './exportOverdueDetailToExcel'

export const TableWidth = styled(Box)(({ theme }) => ({
  '.MuiTable-root': {
    tableLayout: 'fixed',
    '.MuiTableHead-root': {
      '.MuiTableCell-head': {
        '&:nth-of-type(1)': {
          width: '5%'
        },
        '&:nth-of-type(2)': {
          width: '10%'
        },
        '&:nth-of-type(3)': {
          width: '15%'
        },
        '&:nth-of-type(4)': {
          width: '70%'
        },
        '&:nth-of-type(5)': {
          width: '15%'
        },
        '&:nth-of-type(6)': {
          width: '15%',
          padding: 15
        },
        [theme.breakpoints.down('lg')]: {
          '&:nth-of-type(1)': {
            width: '5%'
          },
          '&:nth-of-type(2)': {
            width: '30%'
          },
          '&:nth-of-type(3)': {
            width: '30%'
          },
          '&:nth-of-type(4)': {
            width: '70%'
          },
          '&:nth-of-type(5)': {
            width: '40%'
          },
          '&:nth-of-type(6)': {
            width: '40%',
            padding: 15
          },
        },
        [theme.breakpoints.down('sm')]: {
          '&:nth-of-type(1)': {
            width: '5%'
          },
          '&:nth-of-type(2)': {
            width: '30%'
          },
          '&:nth-of-type(3)': {
            width: '30%'
          },
          '&:nth-of-type(4)': {
            width: '70%'
          },
          '&:nth-of-type(5)': {
            width: '40%'
          },
          '&:nth-of-type(6)': {
            width: '40%',
            padding: 15
          },
        }
      }
    },
    '.MuiTableBody-root': {
      '.MuiTableCell-body': {
        padding: '8px',
        verticalAlign: 'middle',
        '&:first-of-type': {
          paddingLeft: 4,
          paddingRight: 4
        },
        [theme.breakpoints.down('sm')]: {
          verticalAlign: 'top'
        }
      }
    },
  },
  '.MuiTablePagination-selectLabel, .MuiTablePagination-input': {
    display: 'none'
  }
}))

export default function Overdue() {
  const { t } = useTranslation()
  const history = useHistory()
  const [overDue, setOverdue] = useState([])
  const [overDueExport, setOverdueExport] = useState([])
  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('lastPad')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [rangeDate, setRangeDate] = useState<string[]>([moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')])
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [appliedFilters, setAppliedFilters] = useState({
    search: '',
    branchId: getBranch(),
    rangeDate: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  })
  const componentRef = useRef<HTMLDivElement>(null)

  const verifyPermission = async () => {
    ClinicApi.findAllBranches().then(({ data }) => setBranches(data))
  }

  useEffect(() => {
    verifyPermission()
  }, [])


  const loadData = async () => {
    try {
      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (appliedFilters.search) condition = { ...condition, search: appliedFilters.search }
      if (appliedFilters.branchId) condition = { ...condition, branchId: appliedFilters.branchId }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }
      if (appliedFilters.rangeDate) {
        if ((appliedFilters.rangeDate[0] !== null || appliedFilters.rangeDate[0] !== '') && (appliedFilters.rangeDate[1] !== null || appliedFilters.rangeDate[1] !== ''))
          condition = { ...condition, dateStart: appliedFilters.rangeDate[0], dateEnd: appliedFilters.rangeDate[1] }
      }
      const res = await OverdueApi.findAll(condition)
      const resExport = await OverdueApi.findAll({ ...condition, export: 1 })
      if (res.status === 200) {
        setRowCount(res.headers['x-total'])
        setOverdue(res.data)
        setOverdueExport(resExport.data)
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType, appliedFilters])

  const onView = (e: any, objVal: any) => {
    history.push(routeName.overdueDetail, { patientId: objVal.patientId })
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => setPage(val)

  const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'message', disablePadding: false, label: t('APPLICATION.TABLE.CELL.CN_NUMBER'), class: 'text-nowrap' },
    { id: 'branchId', disablePadding: false, label: t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID'), class: 'pr-1 text-nowrap' },
    { id: 'namePatient', disablePadding: false, label: t('OVERDUE_DETAIL.TABLE.NAME_CUSTOMER'), class: 'text-nowrap' },
    { id: 'namePatient', disablePadding: false, label: t('OVERDUE_DETAIL.TABLE.PAY_LASTED'), class: 'text-nowrap' },
    { id: 'typeXray', align: 'right', disablePadding: false, label: t('OVERDUE_DETAIL.TABLE.SUM_PAYED'), class: 'text-nowrap' },
    { id: 'action', align: 'center', disablePadding: false, label: t('Action'), class: 'text-nowrap', width: '80px' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { patientId, cnNumber, branchCnNumber, patientFullName, lastPad, overdue } = objData
    const objRenderData = {
      key: String(no),
      id: patientId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: cnNumber || '-' },
        { option: 'TEXT', align: 'left', label: branchCnNumber || '-' },
        { option: 'TEXT', align: 'left', label: patientFullName },
        { option: 'TEXT', align: 'left', label: dateToView(lastPad) },
        { option: 'TEXT', align: 'right', label: numberToCurrencyFormat(overdue), class: 'text-nowrap' },
        {
          option: 'COMPONENT',
          component: (
            <Box textAlign={'center'}>
              <IconButton
                sx={{ border: `1px solid ${colors.themeSecondColor}`, borderRadius: '4px', padding: '8px' }}
                onClick={() => onView(null, objData)}
              >
                <VisibilityIcon sx={{ color: colors.themeSecondColor }} />
              </IconButton>
            </Box>
          )
        },
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
      // rowLink={true}
      // onClick={(e, val) => onView(e, val)}
      />
    )
  }

  return (
    <Box>
      <HeaderCard text={t('OVERDUE_DETAIL.BREADCRUMB.MAIN')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('OVERDUE_DETAIL.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('REPORT.FILTER.BRANCH')}
              value={branchId}
              onChange={e => {
                setBranchId(Number(e.target.value));
              }}
              options={branches?.map(b => ({
                value: b.branchId,
                name: b.branchName || b.branchNameEn || ''
              }))}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewRangePicker
              value={rangeDate || []}
              inputHeight={40}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else {
                  setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                }
              }}
              allowClear
              onClear={() => setRangeDate(emptyRangePicker)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={1} xl={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '120px' }}
              onClick={() => {
                setPage(1)
                setAppliedFilters({
                  search,
                  branchId,
                  rangeDate
                })
              }} />
          </Grid>
          <Grid item xs={12} sm={5} md={2} xl={5}>
            <Box display={'flex'} justifyContent={'flex-end'}>
              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                  if (e === 'Excel') {
                    const report: any = {
                      title: t('OVERDUE_DETAIL.BREADCRUMB.MAIN'),
                      branchName: `${branches?.find((e: any) => e.branchId === branchId)?.branchName}`,
                      dateStart: rangeDate[0],
                      dateEnd: rangeDate[1],
                      rows: overDueExport,
                      t: t
                    }
                    exportOverdueDetailToExcel(report)
                  } else if (e === 'PDF') {
                    const style = document.createElement("style");
                    style.innerHTML = `
                @media print {
                  @page {size: landscape }
                      }
                `;
                    document.head.appendChild(style);
                    window.print();
                    document.head.removeChild(style);

                  }
                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={overDue.map((val, i) => renderData(val, i))}
          />
        </Box>

        <Box
          id="print-table-container"
          ref={componentRef}
        >
          <Typography fontSize="14px" fontWeight={400}>{t('OVERDUE_DETAIL.BREADCRUMB.MAIN')}</Typography>
          <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2}>
            <Typography fontSize="10px" fontWeight={400}> {t('REPORT.TABLE.DECREASE.BRANCH')}:  {`${branches?.find((e: any) => e.branchId === branchId)?.branchName}`}</Typography>
            <Typography fontSize="10px" fontWeight={400}>{t('REPORT.TABLE.DECREASE.DATE_START')}: {rangeDate[0] ? dateToView(rangeDate[0]) : '-'}</Typography>
            <Typography fontSize="10px" fontWeight={400}>{t('REPORT.TABLE.DECREASE.DATE_END')}: {rangeDate[0] ? dateToView(rangeDate[1]) : '-'}</Typography>
          </Box>

          <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
            <thead>
              <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('TABLE.NO')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('APPLICATION.TABLE.CELL.CN_NUMBER')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OVERDUE_DETAIL.TABLE.NAME_CUSTOMER')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('OVERDUE_DETAIL.TABLE.PAY_LASTED')}</th>
                <th style={{ borderBottom: '1px solid black', textAlign: 'right' }}>{t('OVERDUE_DETAIL.TABLE.SUM_PAYED')}</th>
              </tr>
            </thead>
            <tbody>
              {overDueExport?.length === 0 &&
                <tr>
                  <td colSpan={9} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                </tr>
              }
              {overDueExport.map((data: any, index: number) => (
                <tr key={index}>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100px' }}>{data?.cnNumber || '-'}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '100px' }}>{data?.branchCnNumber || '-'}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.patientFullName || '-'}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center', width: '100px' }}>{dateToView(data.lastPad)}</td>
                  <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'right', verticalAlign: 'center', width: '100px' }}>{numberFormat(data?.overdue || 0)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
    </Box>
  )
}
